import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyABjz5dHjpfm6luk8YrxoCVSZkes4iADi4",
  authDomain: "imin-a07b8.firebaseapp.com",
  projectId: "imin-a07b8",
  storageBucket: "imin-a07b8.firebasestorage.app",
  messagingSenderId: "355678395410",
  appId: "1:355678395410:web:e0ae6ed7a1e3ae63328ccb",
  measurementId: "G-DL76NQ234T"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { db, storage, auth, googleProvider };